import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';

export const UploadCard = styled(ButtonBase)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 16,
  padding: '16px 12px',
  border: `1px solid ${theme.palette.neutrals.beige4}`,
  borderRadius: 8,
  width: '100%',
  textAlign: 'left'
}));

export const UploadCardIcon = styled(Box)(({ theme }) => ({
  width: 48,
  height: 48,
  borderRadius: '50%',
  backgroundColor: theme.palette.brand.lightGreen,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  '& svg': {
    color: theme.palette.brand.mediumGreen
  }
}));

export const UploadCardText = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  flex: 1,
  minWidth: 0,
  alignSelf: 'center'
}));

export const UploadCardTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1B,
  color: theme.palette.brand.darkGreen
}));

export const UploadCardSubtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2R,
  color: theme.palette.brand.darkGreen
}));
